import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Box,
  Typography,
  Link,
  List,
  ListItem,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { motion } from "framer-motion";
import { Navigate, useNavigate } from "react-router-dom";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import BuildIcon from "@mui/icons-material/Build";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import Tooltip from "../../components/Tooltip/Tooltip";
import RecentPosts from "../../components/RecentPosts/RecentPosts";
import MississippiMap from "../../components/MississippiMap/MississippiMap";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { useContext } from "react";
import { AuthContext } from "../../components/Context/AuthContext";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";

import img6 from "../../assets/Images_Hub/Team2025.jpg";
import img1 from "../../assets/Images_Hub/1.jpeg";
import img2 from "../../assets/Canva 1.png";
import img3 from "../../assets/Canva 2.png";
import img4 from "../../assets/Canva 4.png";
import img5 from "../../assets/canva5.png";

import API_URL from "../../config";
import axios from "axios";
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import FacebookPosts from "../../components/FacebookPosts/FacebookPosts";
import API_BASE_URL from "../../utils/api";
import Joyride from "react-joyride";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";

const Home = () => {
  const mapRef = useRef(null);
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    document.title = "MS Digital Hub";
    axios
      .get(`${API_BASE_URL}/blogs`)
      .then((res) => setBlogs(res.data))
      .catch(console.error);
  }, []);
  const offers = [
    {
      title: "Cutting-edge technology for digitally preserving materials",
      icon: <RocketLaunchIcon fontSize="large" color="primary" />,
    },
    {
      title: "Access to tools and software for Digital Humanities projects",
      icon: <BuildIcon fontSize="large" color="primary" />,
    },
    {
      title:
        "Expert assistance and collaboration opportunities to assist with digitization and the digital humanities",
      icon: <PeopleOutlineIcon fontSize="large" color="primary" />,
    },
    {
      title:
        "Mini-grants to facilitate projects and spur Mississippi community initiatives",
      icon: <MonetizationOnIcon fontSize="large" color="primary" />,
    },
    {
      title:
        "One-day workshops and residential summer courses for summers 2025, 2026, and 2027",
      icon: <CastForEducationIcon fontSize="large" color="primary" />,
    },
  ];
  const navigate = useNavigate();
  const betaSlides = [
    {
      key: "cookbook",
      title: "Transcribe a recipe",
      subtitle: "Cookbook project — try a sample page (demo)",
      description:
        "Turn a scanned recipe into text and fix two lines in seconds.",
      cta: "Try the demo",
      onClick: () => navigate("/transcription-tool"),
      Icon: DescriptionOutlinedIcon,
    },
    {
      key: "threads",
      title: "Chat thread",
      subtitle: "Collaborative post — title, description & visibility",
      description:
        "Start a thread and choose who should see it: all registered or a workshop.",
      cta: "Open composer",
      onClick: () => navigate("/chat-room"),
      Icon: ForumOutlinedIcon,
    },
  ];
  const [active, setActive] = useState(0);
  const next = () => setActive((i) => (i + 1) % betaSlides.length);
  const prev = () =>
    setActive((i) => (i - 1 + betaSlides.length) % betaSlides.length);

  const { user } = useContext(AuthContext);

  const [cookbookDocId, setCookbookDocId] = useState(null);
  const [recipePages, setRecipePages] = useState([]);
  const [activeIdx, setActiveIdx] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImg, setPreviewImg] = useState("");
  const [previewRoute, setPreviewRoute] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");

    async function fetchPublic() {
      try {
        const { data } = await axios.get(
          `${API_BASE_URL}/documents/public/cookbook-preview?limit=5`
        );
        setCookbookDocId(data.documentId);
        setRecipePages(
          (data.pages || []).map((p) => ({
            src: p.imageUrl,
            pageNumber: p.pageNumber,
          }))
        );
      } catch {
        setRecipePages([]);
      }
    }

    async function fetchPrivate() {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/documents`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        const docs = Array.isArray(data) ? data : [];
        const isCookbook = (d) => {
          const cat = (d.category || "").toLowerCase();
          const title = (d.title || "").toLowerCase();
          const desc = (d.description || "").toLowerCase();
          return ["cookbook", "recipe", "recipes"].some(
            (k) => cat.includes(k) || title.includes(k) || desc.includes(k)
          );
        };
        const doc = docs.find(isCookbook);
        if (!doc) return fetchPublic();

        setCookbookDocId(doc.documentId);

        const sorted = (doc.pages || []).sort(
          (a, b) => a.pageNumber - b.pageNumber
        );
        const notStarted = sorted.filter(
          (p) => (p.status || "").toLowerCase() === "not started"
        );
        const pick = (notStarted.length ? notStarted : sorted).slice(0, 5);
        setRecipePages(
          pick.map((p) => ({ src: p.imageUrl, pageNumber: p.pageNumber }))
        );
      } catch {
        fetchPublic();
      }
    }

    if (!token) fetchPublic();
    else fetchPrivate();
  }, []);
  const [previewMsg, setPreviewMsg] = useState("");
  const isLoggedIn = !!localStorage.getItem("token");
  const openPopup = (route, img, msg) => {
    setPreviewRoute(route);
    setPreviewImg(img || "");
    setPreviewMsg(
      msg ||
        "You’re not logged in. Please log in (or create an account) to continue."
    );
    setPreviewOpen(true);
  };
  const openPage = (idx) => {
    const pg = recipePages[idx];
    if (!pg) return;
    const route = `/document/${cookbookDocId || "unknown"}/page/${pg.pageNumber}`;
    if (user && cookbookDocId) {
      navigate(route);
    } else {
      openPopup(
        route,
        pg.src,
        "You’re not logged in. To try transcribing this page, please log in—or create an account and log in."
      );
    }
  };

  const nextSlide = () =>
    setActiveIdx((i) => (i + 1) % Math.max(recipePages.length, 1));
  const prevSlide = () =>
    setActiveIdx(
      (i) =>
        (i - 1 + Math.max(recipePages.length, 1)) %
        Math.max(recipePages.length, 1)
    );
  const tileH = { xs: 180, sm: 180, md: 180 };
  const [runTour, setRunTour] = useState(false);
  const joyrideSteps = [
    {
      target: "#try-recipe-card",
      content:
        "Try our cookbook project: browse a page or use the editor to get a feel for transcribing.",
      disableBeacon: true,
    },
    {
      target: "#try-recipe-carousel",
      content: "Use the arrows to browse pages. Click any page to open it.",
      placement: "left",
      disableBeacon: true,
    },

    {
      target: "#try-recipe-open",
      content: "Open the full project here.",
      placement: "top",
      disableBeacon: true,
    },
  ];

  const demoScript = `This is the transcription area.\n\n`;

  const [typed, setTyped] = useState("");
  useEffect(() => {
    if (user) return;
    let i = 0;
    const id = setInterval(() => {
      setTyped(demoScript.slice(0, i));
      i += 2;
      if (i > demoScript.length) clearInterval(id);
    }, 45);
    return () => clearInterval(id);
  }, [user]);
  const [stepIndex, setStepIndex] = useState(0);
  const [tourKey, setTourKey] = useState(0);

  const startTour = () => {
    setStepIndex(0);
    setRunTour(false);
    setTimeout(() => {
      setTourKey((k) => k + 1);
      setRunTour(true);
    }, 0);
  };
  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Joyride
        key={tourKey}
        run={runTour}
        stepIndex={stepIndex}
        steps={joyrideSteps}
        continuous
        showSkipButton
        disableOverlayClose
        disableScrolling
        scrollToFirstStep={false}
        styles={{
          options: { primaryColor: "#1976d2", zIndex: 10000 },
          tooltipContainer: { borderRadius: 8, fontSize: 14 },
        }}
        callback={(data) => {
          const { status, type, index } = data;
          if (type === "step:after") setStepIndex(index + 1);
          if (
            status === "finished" ||
            status === "skipped" ||
            type === "tour:end"
          ) {
            setRunTour(false);
            setStepIndex(0);
          }
        }}
      />
      {/* <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          color: "#555",
          textAlign: "center",
          fontWeight:"bold",
          fontSize:"20px",
          
        }}
      >
      </Typography>*/}
      {/*   <Box
      sx={{
        backgroundColor: '#fff',
        
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2,
        marginBottom:'50px'
      }}
    >
     <Container maxWidth="md">
        <Typography
          variant="h5"
          sx={{
            lineHeight: 1.2,
            color:'#444'
            
          }}
        >
                  The {' '}
                  <Box component="span" sx={{  padding:'0 6px', borderRadius:'4px', fontStyle:'oblique' }}>
                  "Hub"         </Box> at Southern Miss Supports 
                  <Box component="span" sx={{  padding:'0 6px', borderRadius:'4px', fontStyle:'oblique' }}>
                  Digitization        </Box> and {' '}
                  <Box component="span" sx={{  padding:'0 6px', borderRadius:'4px', fontStyle:'oblique' }}>
                  Digital Humanities       </Box> in Mississippi 
                     </Typography>
      </Container> 
    </Box>*/}
      {/*  <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          color: "#555",
          textAlign: "center",
          fontWeight:"bold",
          fontStyle:"italic",
          fontSize:"18px"
          
        }}
      >
        The Hub provides support for Mississippi scholars and archivists seeking to
        preserve local resources through digitization and the digital humanities.
      </Typography>
      */}
      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          paddingLeft: "10px",
          textAlign: "center",
        }}
      >
        Mississippi and the Digital Humanities
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        The <strong>Mississippi Digital Humanities Hub</strong> at{" "}
        <Tooltip
          keyword="The University of Southern Mississippi"
          url="https://www.usm.edu"
        />{" "}
        provides resources and training so that local institutions - four-year
        and two-year colleges and universities, high schools, museums, and
        libraries - can pursue community-based projects that highlight and
        preserve the rich history of Mississippi. The Hub offers workshops to
        train college and high school instructors and students in the types of
        tools needed to document their communities, dispenses grants to help
        spur community initiatives, and provides experts and software to help
        interpret the materials being digitized.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        Digitizing local historical and cultural archives helps to preserve the
        past and make materials more accessible, but it can be difficult for the
        public to make sense of large collections of documents. When
        digitization initiatives are paired with digital humanities tools and
        methods, new insights are revealed. We provide the training and support
        to make both digitization and the digital humanities possible in
        Mississippi.
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            backgroundColor: "#FFD700",
            color: "#000000",
            padding: "12px 20px",
            "&:hover": { backgroundColor: "#FFB800" },
          }}
          onClick={() => navigate("/dh")}
        >
          What are the "Digital Humanities"?
        </Button>
      </Box>
      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          paddingLeft: "10px",
          textAlign: "center",
        }}
      >
        Who We Are
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "40px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        The Mississippi Digital Humanities Hub is a grant-funded initiative of
        the{" "}
        <Tooltip
          keyword="Center for Digital Humanities"
          url="https://www.usmcdh.org/"
        />{" "}
        at The University of Southern Mississippi. The Hub receives
        Congressionally allocated funding administered by the{" "}
        <Tooltip
          keyword="National Historical Publications and Records Commission"
          url="https://www.archives.gov/nhprc"
        />
        (NHPRC), a part of the{" "}
        <Tooltip
          keyword="National Archives and Records Administration"
          url="https://www.archives.gov/"
        />
        (NARA).{" "}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: 4,
          mb: "40px",
          alignItems: { xs: "center", md: "center", lg: "flex-start" },
        }}
      >
        <Box sx={{ flex: 1.5 }}>
          <Grid container rowSpacing={1} alignItems="center" columnSpacing={0}>
            <Grid
              item
              xs={12}
              lg={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Box
                sx={{
                  borderRadius: 2,
                  overflow: "hidden",
                  width: "100%",
                  aspectRatio: "16/9",
                }}
              >
                <ImageCarousel
                  images={[img6]}
                  rounded={true}
                  aspectRatio="16/9"
                />
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              lg={4}
              sx={{
                borderRadius: 2,
                p: { xs: 2, md: 3 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                fontFamily: "Cursive",
                color: "#444",
                ml: { lg: -6, md: 0, sm: 0, xs: 0 },
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <Typography
                  variant="h5"
                  fontWeight={700}
                  gutterBottom
                  sx={{
                    color: "#FFD700",
                    fontStyle: "italic",
                    letterSpacing: 1.5,
                  }}
                >
                  The People Powering the Hub
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                    letterSpacing: 1.5,
                    color: "#333",
                  }}
                >
                  Together, we're making sure Mississippi's stories are
                  preserved.
                </Typography>
              </motion.div>
            </Grid>

            {/* <Grid item xs={12} md={12} sx={{ mt: { xs: 4, md: 4 } }}>
              {" "}
              <Box
                sx={{
                  textAlign: "center",
                  mb: 3,
                  px: { xs: 2, md: 4 },
                }}
              >
                {" "}
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: "#FFD700",
                    mb: 1,
                    fontStyle: "italic",
                  }}
                >
                  Explore Our Beta Tools{" "}
                </Typography>{" "}
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1rem",
                    color: "#555",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  Get a sneak peek at what the Hub is building.{" "}
                </Typography>{" "}
              </Box>
              
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "center",
                  alignItems: "stretch",
                  gap: { xs: 3, md: 5 },
                  p: { xs: 2, md: 4 },
                }}
              >
               
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 250 }}
                  style={{ cursor: "pointer", flex: 1 }}
                  onClick={() => (window.location.href = "/transcription-tool")} // Dummy URL
                >
                  {" "}
                  <Box
                    sx={{
                      backgroundColor: "#FFF8DC",
                      borderRadius: "16px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      p: 3,
                      textAlign: "center",
                      minHeight: "150px",
                    }}
                  >
                    <Box sx={{ fontSize: 40, mb: 1 }}> </Box>{" "}
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                      Transcription Tool{" "}
                    </Typography>{" "}
                    <Typography variant="body2" sx={{ color: "#555" }}>
                      Transcribe historical documents with ease.{" "}
                    </Typography>{" "}
                  </Box>{" "}
                </motion.div>
               
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 250 }}
                  style={{ cursor: "pointer", flex: 1 }}
                  onClick={() => (window.location.href = "/chat-room")} // Dummy URL
                >
                  {" "}
                  <Box
                    sx={{
                      backgroundColor: "#F0F4FF",
                      borderRadius: "16px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      p: 3,
                      textAlign: "center",
                      minHeight: "150px",
                    }}
                  >
                    <Box sx={{ fontSize: 40, mb: 1 }}> </Box>{" "}
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                      Chat Room{" "}
                    </Typography>{" "}
                    <Typography variant="body2" sx={{ color: "#555" }}>
                      Collaborate and discuss projects asynchronously.{" "}
                    </Typography>{" "}
                  </Box>{" "}
                </motion.div>{" "}
              </Box>
            </Grid> */}

            <Grid
              item
              xs={12}
              lg={8}
              sx={{
                borderRadius: 2,
                p: { xs: 2, md: 3 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",

                fontFamily: "Cursive",
                color: "#333",
                mr: { lg: -5, md: 0, sm: 0, xs: 0 },
                mt: "30px",
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <Typography
                  variant="h5"
                  fontWeight={700}
                  gutterBottom
                  sx={{
                    color: "#FFD700",
                    fontStyle: "italic",
                    letterSpacing: 1.5,
                    textAlign: "center",
                  }}
                >
                  Our Story in Snaps
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                    letterSpacing: 1.5,
                    color: "#333",
                    maxWidth: "520px",
                    textAlign: "center",
                  }}
                >
                  Glimpses into the work we do at the Hub.
                </Typography>
              </motion.div>

              <Box sx={{ mt: 0, width: "100%" }}>
                <MississippiMap ref={mapRef} />
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              lg={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",

                color: "#333",
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <Typography
                  variant="h5"
                  fontWeight={700}
                  gutterBottom
                  sx={{
                    color: "#FFD700",
                    fontStyle: "italic",
                    letterSpacing: 1.5,

                    textAlign: "center",
                  }}
                >
                  Transcription Tool
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                    letterSpacing: 1.5,
                    color: "#333",

                    textAlign: "center",
                  }}
                >
                  Try a page to get a feel for the tools. (Edits here aren’t
                  saved.){" "}
                </Typography>
              </motion.div>

              <Card
                id="try-recipe-card"
                sx={{
                  p: { xs: 1.25, md: 1.75 },
                  borderRadius: 1,
                  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.25,
                  mt: "10px",
                }}
              >
                {" "}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {" "}
                  <Avatar
                    sx={{ bgcolor: "primary.main", width: 32, height: 32 }}
                  >
                    {" "}
                    <EditNoteIcon sx={{ color: "white", fontSize: 18 }} />{" "}
                  </Avatar>{" "}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500, lineHeight: 1.2 }}
                  >
                    Transcribe a recipe{" "}
                  </Typography>{" "}
                  <Box
                    onClick={startTour}
                    role="button"
                    aria-label="Show quick tour"
                    sx={{
                      ml: 1,
                      display: "inline-flex",
                      alignItems: "center",
                      cursor: "pointer",
                      position: "relative",
                      borderRadius: "50%",
                      p: 0.25,
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        inset: -6,
                        borderRadius: "50%",
                        border: "2px solid rgba(25,118,210,0.35)",
                        animation: "helperPulse 1.6s ease-out infinite",
                      },
                      "@keyframes helperPulse": {
                        "0%": { transform: "scale(0.9)", opacity: 0.6 },
                        "70%": { transform: "scale(1.15)", opacity: 0 },
                        "100%": { transform: "scale(0.9)", opacity: 0 },
                      },
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 24,
                        height: 24,
                        bgcolor: "white",
                        boxShadow: 1,
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <HelpOutlineIcon fontSize="small" color="primary" />
                    </Avatar>
                  </Box>
                </Box>{" "}
                <Grid container spacing={1.5} alignItems="stretch">
                  <Grid item xs={6} sx={{ display: "flex" }}>
                    {" "}
                    <Box
                      id="try-recipe-carousel"
                      sx={{
                        position: "relative",
                        borderRadius: 1.5,
                        overflow: "hidden",
                        border: "1px solid",
                        borderColor: "divider",
                        height: { xs: 180, sm: 220, md: 300 },
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "background.default",
                        cursor: "pointer",
                        "&:hover::after": {
                          content: '"Click to open"',
                          position: "absolute",
                          bottom: 8,
                          left: 8,
                          fontSize: 11,
                          background: "rgba(255,255,255,0.9)",
                          padding: "2px 6px",
                          borderRadius: 6,
                        },
                      }}
                      onClick={() => openPage(activeIdx)}
                    >
                      {" "}
                      {recipePages.length > 0 && (
                        <Box sx={{ width: "100%", height: "100%" }}>
                          {" "}
                          <img
                            src={recipePages[activeIdx]?.src}
                            alt={`Page ${recipePages[activeIdx]?.pageNumber}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              background: "#f7f7f7",
                              display: "block",
                            }}
                          />{" "}
                        </Box>
                      )}
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          prevSlide();
                        }}
                        size="small"
                        sx={{
                          position: "absolute",
                          left: 6,
                          top: "50%",
                          transform: "translateY(-50%)",
                          bgcolor: "white",
                          boxShadow: 1,
                          "&:hover": { bgcolor: "white" },
                        }}
                        aria-label="Previous page"
                      >
                        <ChevronLeftIcon fontSize="small" />{" "}
                      </IconButton>{" "}
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          nextSlide();
                        }}
                        size="small"
                        sx={{
                          position: "absolute",
                          right: 6,
                          top: "50%",
                          transform: "translateY(-50%)",
                          bgcolor: "white",
                          boxShadow: 1,
                          "&:hover": { bgcolor: "white" },
                        }}
                        aria-label="Next page"
                      >
                        <ChevronRightIcon fontSize="small" />{" "}
                      </IconButton>
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 6,
                          left: 0,
                          right: 0,
                          display: "flex",
                          justifyContent: "center",
                          gap: 0.75,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {" "}
                        {recipePages.map((_, i) => (
                          <Box
                            key={i}
                            onClick={() => setActiveIdx(i)}
                            sx={{
                              width: 6,
                              height: 6,
                              borderRadius: "50%",
                              bgcolor:
                                i === activeIdx ? "primary.main" : "grey.400",
                              cursor: "pointer",
                            }}
                          />
                        ))}{" "}
                      </Box>{" "}
                    </Box>{" "}
                  </Grid>
                  <Grid item xs={6} sx={{ display: "flex" }}>
                    {" "}
                    <Box
                      id="try-recipe-editor"
                      onClick={() => openPage(activeIdx)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) =>
                        (e.key === "Enter" || e.key === " ") &&
                        openPage(activeIdx)
                      }
                      sx={{
                        cursor: "pointer",
                        height: { xs: 180, sm: 220, md: 300 },
                        width: "100%",
                        p: 1,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1.5,
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        "@keyframes blinkCaret": {
                          "0%, 100%": { opacity: 0 },
                          "50%": { opacity: 1 },
                        },
                      }}
                    >
                      {" "}
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 500, mb: 0.5 }}
                      >
                        Transcribe{" "}
                      </Typography>
                      <TextField
                        id="transcribe-input"
                        fullWidth
                        multiline
                        size="small"
                        placeholder={
                          user ? "Type a few lines from the page…" : ""
                        }
                        disabled={!user}
                        helperText={
                          user
                            ? "This is a demo field. Visit the page to save."
                            : "Login to try transcribing."
                        }
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                          flex: 1,
                          "& .MuiOutlinedInput-root": {
                            height: "100%",
                            alignItems: "flex-start",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: 13,
                            lineHeight: 1.4,
                            py: 0.75,
                          },
                          "& .MuiFormHelperText-root": {
                            mt: 0.5,
                            fontSize: 11,
                          },
                        }}
                      />{" "}
                      {!user && (
                        <Box
                          aria-hidden
                          sx={{
                            pointerEvents: "none",
                            position: "absolute",
                            left: 12,
                            right: 12,
                            bottom: 28,
                            top: 36,
                            color: "text.secondary",
                            fontSize: 13,
                            whiteSpace: "pre-wrap",
                            lineHeight: 1.4,
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <span>{typed}</span>{" "}
                          <Box
                            component="span"
                            sx={{
                              width: 1,
                              height: "1em",
                              bgcolor: "text.secondary",
                              ml: 0.25,
                              animation: "blinkCaret 1s step-end infinite",
                            }}
                          />{" "}
                        </Box>
                      )}{" "}
                    </Box>{" "}
                  </Grid>{" "}
                </Grid>
                <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                  {" "}
                  <Button
                    id="try-recipe-open"
                    size="small"
                    variant="outlined"
                    sx={{
                      px: 1.5,
                    }}
                    onClick={() => {
                      if (user && cookbookDocId) {
                        navigate(`/transcription/documents/${cookbookDocId}`);
                      } else {
                        const cur = recipePages[activeIdx];
                        openPopup(
                          "/login",
                          cur?.src,
                          "Please log in (or register) to open the cookbook project."
                        );
                      }
                    }}
                  >
                    Open project{" "}
                  </Button>{" "}
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            flex: "0.5",
            display: "flex",
            flexDirection: "column",
            gap: { xs: 3, md: 2 },
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            p: 2,
          }}
        >
          <FacebookPosts />

          <RecentPosts posts={blogs} />
        </Box>
      </Box>
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          mb: 4,
          marginBottom: "30px",
        }}
      >
        What the Mississippi Digital Humanities Hub Offers
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(5, 1fr)",
          },
          gap: 3,
          marginBottom: "30px",
        }}
      >
        {offers.map((offer, index) => (
          <Card
            key={index}
            sx={{
              p: 2,
              borderRadius: 2,
              boxShadow: 3,
              textAlign: "center",
            }}
          >
            <CardContent>
              {offer.icon}
              <Typography variant="h7" sx={{ mt: 2 }}>
                <br />
                {offer.title}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
      {/* CTA Section
      <Box sx={{ textAlign: "center", marginBottom: "40px" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FFD700",
            color: "#111111",
            padding: "12px 20px",
            fontWeight: "bold",
            '&:hover': { backgroundColor: "#FFB800" },
          }}
        >
          Get Involved
        </Button>
      </Box>  */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Login required</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              borderRadius: 1,
              overflow: "hidden",
              border: "1px solid",
              borderColor: "divider",
              mb: 2,
            }}
          >
            <Box
              sx={{
                height: 220,
                backgroundImage: `url(${previewImg})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                filter: "blur(3px) brightness(0.9)",
                bgcolor: "#f7f7f7",
              }}
            />
          </Box>
          <Typography sx={{ mb: 1 }}>
            {previewMsg ||
              "You’re not logged in. Please log in (or register) to continue."}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button onClick={() => setPreviewOpen(false)}>Cancel</Button>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="outlined" onClick={() => navigate("/signup")}>
              Register
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                localStorage.setItem("redirectAfterLogin", previewRoute);
                navigate("/login");
              }}
              sx={{ backgroundColor: "#1976d2" }}
            >
              Login
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Home;
